// extracted by css-extract-rspack-plugin
export default {"alerts":"index__alerts___znmL9","alert":"index__alert___O9oXO","alertText":"index__alertText___xEI0F","link":"index__link___bRPTy"};